module.exports = __webpack_public_path__ + "img/icon-lock-white-secure.9cc68087.svg";